import { getInitialTimezone } from '~/utils/dayjs';

export interface IBuildTimezoneQueryParams {
  timezone?: string;
}

const build = (timezone?: string) => {
  const tz = timezone ?? getInitialTimezone();
  return tz ? `TIMEZONE ${tz}` : '';
};

const parse = (query: string): string | undefined => {
  const match = query.match(/\bTIMEZONE\s+(\S+)/i);
  return match?.[1];
};

export { build as buildTimezoneQuery, parse as parseTimezoneQuery };
